module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"language":"Sprache"},"en":{"language":"Language"}}')
  delete Component.options._Ctor
}
